var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-responsive",style:(_vm.dimensionStyles)},[(_vm.aspectStyle)?_c('div',{staticClass:"v-responsive__sizer",style:(_vm.aspectStyle)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"v-responsive__content",class:_vm.contentClass},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }